const router = [
  {
    path: '/grupo-preparacao',
    name: 'grupo-preparacao',
    meta: {
      tagTela: 'grupopreparacao',
      tagTelaFuncao: 'read',
      breadCrumb: 'Grupo de Preparação',
      hasProgress: true
    },
    component: () => import('@/views/merenda/GrupoPreparacao.vue'),
  },
  {
    path: '/preparacao',
    name: 'preparacao',
    meta: {
      tagTela: 'preparacao',
      tagTelaFuncao: 'read',
      breadCrumb: 'Preparação',
      hasProgress: true
    },
    component: () => import('@/views/merenda/Preparacao.vue'),
  },
  {
    path: '/composicao-preparacao',
    name: 'composicao-preparacao',
    meta: {
      tagTela: 'composicaopreparacao',
      tagTelaFuncao: 'read',
      breadCrumb: 'Composição da Preparação',
      hasProgress: true
    },
    component: () => import('@/views/merenda/ComposicaoPreparacao.vue'),
  },
  {
    path: '/tipo-cardapio',
    name: 'tipo-cardapio',
    meta: {
      tagTela: 'tipocardapio',
      tagTelaFuncao: 'read',
      breadCrumb: 'Tipo de Cardápio',
      hasProgress: true
    },
    component: () => import('@/views/merenda/TipoCardapio.vue'),
  },
  {
    path: '/elaboracao-cardapio',
    name: 'elaboracao-cardapio',
    meta: {
      tagTela: 'elaboracaocardapio',
      tagTelaFuncao: 'read',
      breadCrumb: 'Elaboração Cardápio',
      hasProgress: true
    },
    component: () => import('@/views/merenda/ElaboracaoCardapio.vue'),
  },
  {
    path: '/elaboracao-cardapio/lancamento',
    name: 'lancar-entrada-cardapio',
    meta: {
      tagTela: 'elaboracaocardapio',
      tagTelaFuncao: 'read',
      breadCrumb: 'Lançamento de Cardápio',
      hasProgress: true
    },
    component: () => import('@/views/merenda/LancamentoCardapio.vue'),
  },
  {
    path: '/cadastro-cardapio-unidade-escolar',
    name: 'cadastro-cardapio-unidade-escolar',
    meta: {
      tagTela: 'cardapiounidadeescol',
      tagTelaFuncao: 'read',
      breadCrumb: 'Cadastro Cardápio/Unidade Escolar',
      hasProgress: true
    },
    component: () => import('@/views/merenda/CardapioUnidadeEscolar.vue'),
  },
  {
    path: '/cardapio-turma',
    name: 'cardapio-turma',
    meta: {
      tagTela: 'cardapioturma',
      tagTelaFuncao: 'read',
      breadCrumb: 'Cadastro Cardápio/Turma',
      hasProgress: true
    },
    component: () => import('@/views/merenda/CardapioTurma.vue'),
  },
  {
    path: '/saida-turma',
    name: 'saida-turma',
    meta: {
      tagTela: 'saidaturma',
      tagTelaFuncao: 'read',
      breadCrumb: 'Saída Turma',
      hasProgress: true
    },
    component: () => import('@/views/merenda/SaidaTurma.vue'),
  },
  {
    path: '/cota',
    name: 'cota',
    meta: {
      tagTela: 'cotaalimentar',
      tagTelaFuncao: 'read',
      breadCrumb: 'Cota',
      hasProgress: true
    },
    component: () => import('@/views/merenda/Cota.vue'),
  },
  {
    path: '/tipo-movimento-deposito-escola',
    name: 'tipo-movimento-deposito-escola',
    meta: {
      tagTela: 'tipomovimentodeposit',
      tagTelaFuncao: 'read',
      breadCrumb: 'Tipo do Movimento do Depósito na Escola',
      hasProgress: true
    },
    component: () => import('@/views/merenda/TipoMovimentoDepositoEscola.vue'),
  },
  {
    path: '/fornecedor',
    name: 'fornecedor',
    meta: {
      tagTela: 'fornecedor',
      tagTelaFuncao: 'read',
      breadCrumb: 'Fornecedor',
      hasProgress: true
    },
    component: () => import('@/views/merenda/Fornecedor.vue'),
  },
  {
    path: '/deposito-da-escola',
    name: 'deposito-da-escola',
    meta: {
      tagTela: 'depositodaescola',
      tagTelaFuncao: 'read',
      breadCrumb: 'Estoque da Escola',
      hasProgress: true
    },
    component: () => import('@/views/merenda/DepositoDaEscola.vue'),
  },
  {
    path: '/usuario-deposito',
    name: 'usuario-deposito',
    meta: {
      tagTela: 'usuariodeposito',
      tagTelaFuncao: 'read',
      breadCrumb: 'Cadastro de usuário e seus depósitos',
      hasProgress: true
    },
    component: () => import('@/views/merenda/UsuarioDeposito.vue'),
  },
  {
    path: '/movimento-estoque',
    name: 'movimento-estoque',
    meta: {
      tagTela: 'movimentoestoque',
      tagTelaFuncao: 'read',
      breadCrumb: 'Movimento do Estoque',
      hasProgress: true
    },
    component: () => import('@/views/merenda/MovimentoDeposito.vue'),
  },
  {
    path: '/controle-diario-merenda',
    name: 'controle-diario-merenda',
    meta: {
      tagTela: 'movdiariomerenda',
      tagTelaFuncao: 'read',
      breadCrumb: 'Controle Diário da Merenda',
      hasProgress: true
    },
    component: () => import('@/views/merenda/ControleMerendaDia.vue'),
  },
  {
    path: '/composicao-alimento-padrao',
    name: 'composicao-alimento-padrao',
    meta: {
      tagTela: 'composicaoalimentopa',
      tagTelaFuncao: 'read',
      breadCrumb: 'Composição do Alimento Padrão',
      hasProgress: true
    },
    component: () => import('@/views/merenda/ComposicaoAlimentoPadrao.vue'),
  },
];

export default router;
